import React, { useState, useEffect } from 'react';
import { View, StyleSheet, ScrollView, Alert, Modal, TouchableOpacity } from 'react-native';
import { Card, Title, Text, Button, Divider, ActivityIndicator, List, useTheme } from 'react-native-paper';
import { getChildById, getChildActivities, deleteChild } from '../../api/childrenAPI';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { API_BASE_URL } from '../../api/axiosConfig';

const ChildDetailScreen = ({ navigation, route }) => {
  const theme = useTheme();
  const { childId } = route.params;
  
  // State variables
  const [child, setChild] = useState(null);
  const [activities, setActivities] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [errorModalVisible, setErrorModalVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  
  // Fetch child and activities data
  useEffect(() => {
    fetchChildData();
  }, [childId]);
  
  // Fetch child data
  const fetchChildData = async () => {
    setIsLoading(true);
    setError(null);
    
    try {
      // Fetch child details
      const childResponse = await getChildById(childId);
      //console.log('Child response:', childResponse);
      
      // Kontrol et: child bilgisi API yanıtının child özelliğinde mi?
      if (childResponse.child) {
        setChild({
          id: childResponse.child.id,
          name: childResponse.child.first_name || childResponse.child.name || '',
          surname: childResponse.child.last_name || childResponse.child.surname || '',
          dateOfBirth: childResponse.child.birthdate || childResponse.child.dateOfBirth,
          gender: childResponse.child.gender || 'unknown',
          tcIdNumber: childResponse.child.tc_id_number || childResponse.child.tcIdNumber,
          hasSpecialNeeds: childResponse.child.special_needs || childResponse.child.hasSpecialNeeds || false,
          allergies: childResponse.child.allergies || childResponse.child.allergy || '',
          specialNotes: childResponse.child.notes || childResponse.child.specialNotes || ''
        });
      } else if (childResponse.data) {
        // Eğer data içinde ise
        const childData = childResponse.data;
        //console.log('Child data from response:', childData);
        
        setChild({
          id: childData.id,
          name: childData.first_name || childData.name || '',
          surname: childData.last_name || childData.surname || '',
          dateOfBirth: childData.birthdate || childData.dateOfBirth,
          gender: childData.gender || 'unknown',
          tcIdNumber: childData.tc_id_number || childData.tcIdNumber,
          hasSpecialNeeds: childData.special_needs || childData.hasSpecialNeeds || false,
          allergies: childData.allergies || childData.allergy || '',
          specialNotes: childData.notes || childData.specialNotes || ''
        });
        
        //console.log('Processed child data:', {
        //  dateOfBirth: childData.birthdate || childData.dateOfBirth,
        //  parsedDate: new Date(childData.birthdate || childData.dateOfBirth)
       // });
      } else {
        throw new Error('Çocuk verisi bulunamadı');
      }
      
      // Fetch child activities
      // Şimdilik boş bırak, gerekirse implementasyon ekle
      // const activitiesResponse = await getChildActivities(childId);
      // setActivities(activitiesResponse.activities || []);
    } catch (err) {
      console.error('Error fetching child data:', err);
      setError(err.message || 'Çocuk bilgileri yüklenirken bir hata oluştu');
    } finally {
      setIsLoading(false);
    }
  };
  
  // Edit child
  const handleEditChild = () => {
    navigation.navigate('AddChild', { childId });
  };
  
  // Create new activity
  const handleCreateActivity = () => {
    navigation.navigate('Activities', { 
      screen: 'CreateActivity',
      params: { selectedChildId: childId }
    });
  };
  
  // Delete child - Alert kullanmadan direkt silme işlemi
  const handleDeleteChild = () => {
    //console.log('SİLME FONKSİYONU ÇALIŞTI');
    //console.log('Child ID:', childId);
    
    // Alert yerine doğrudan arayüzde silme işlemini yapan bir fonksiyon
    const performDelete = async () => {
      try {
        //console.log('SİLME İŞLEMİ BAŞLADI');
        const numericId = parseInt(childId, 10);
        //console.log('ID:', numericId);
        
        // Direkt axios çağrısı
        //console.log('DELETE API ÇAĞRILIYOR...');
        const response = await axios.delete(`${API_BASE_URL}/children/${numericId}`, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${await AsyncStorage.getItem('token')}`
          }
        });
        
        //console.log('SİLME BAŞARILI:', response.data);
        Alert.alert('Başarılı', 'Çocuk silindi!');
        navigation.goBack();
      } catch (error) {
        console.error('SİLME HATASI:', error);
        Alert.alert('Hata', 'Silme işlemi başarısız oldu.');
      }
    };
    
    // İki butonlu bir Modal göster
    setShowModal(true);
  };
  
  // Modal kapatma
  const closeModal = () => {
    setShowModal(false);
  };
  
  // Silme işlemini gerçekleştir
  const confirmDelete = async () => {
    closeModal();
    
    try {
      //console.log('SİLME İŞLEMİ BAŞLADI');
      const numericId = parseInt(childId, 10);
      //console.log('ID:', numericId);
      
      // Direkt axios çağrısı
      //console.log('DELETE API ÇAĞIRILIYOR...');
      const response = await axios.delete(`${API_BASE_URL}/children/${numericId}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${await AsyncStorage.getItem('token')}`
        }
      });
      
      //console.log('SİLME BAŞARILI:', response.data);
      Alert.alert('Başarılı', 'Çocuk silindi!');
      navigation.goBack();
    } catch (error) {
      console.error('SİLME HATASI:', error);
      
      // Hata mesajını kontrol et
      let errorMsg = '';
      
      if (error.response && error.response.data) {
        errorMsg = error.response.data.message || 'Bilinmeyen hata';
        //console.log('HATA MESAJI:', errorMsg);
        
        // Aktif ziyaret hatasını kontrol et
        if (errorMsg.includes('aktif ziyaret') || 
            errorMsg.includes('aktif aktivite') || 
            errorMsg.includes('etkinlik kaydı') ||
            errorMsg.includes('active activity') ||
            errorMsg.includes('active visit')) {
          
          // Aktif ziyaret hatası için özel modal göster
          setErrorMessage(`"${child.name} ${child.surname}" isimli çocuğun aktif bir ziyaret kaydı bulunduğu için silinemiyor. Çocuğu silebilmek için önce aktif ziyaretini tamamlamalısınız.`);
          setErrorModalVisible(true);
          return;
        }
      }
      
      // Diğer hatalar için normal uyarı göster
      Alert.alert('Hata', 'Silme işlemi başarısız oldu: ' + errorMsg);
    }
  };
  
  // Hata modalını kapat
  const closeErrorModal = () => {
    setErrorModalVisible(false);
  };
  
  // Aktif ziyaretler sayfasına git
  const goToActiveVisits = () => {
    setErrorModalVisible(false);
    navigation.navigate('Activities', {
      screen: 'ActiveParkActivities'
    });
  };
  
  // Get child age
  const calculateAge = (birthdate) => {
    if (!birthdate) return 0;
    
    try {
      const today = new Date();
      
      // Tarih formatını düzenle ve doğru parse et
      let birthDate;
      
      if (typeof birthdate === 'string') {
        // API'den "YYYY-MM-DD" formatında geliyorsa (ISO formatı)
        // Saat dilimi sorunlarını önlemek için düzeltelim
        const parts = birthdate.split('T')[0].split('-');
        if (parts.length === 3) {
          birthDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
        } else {
          birthDate = new Date(birthdate);
        }
      } else {
        birthDate = new Date(birthdate);
      }
      
      // Debug logları
      //console.log('Doğum tarihi (orijinal):', birthdate);
      //console.log('Doğum tarihi (parse edilmiş):', birthDate);
      //console.log('Bugün:', today);
      
      // Invalid date kontrolü
      if (isNaN(birthDate.getTime())) {
        console.error('Geçersiz tarih formatı:', birthdate);
        return 0;
      }
      
      // Doğum tarihi gelecekte mi kontrolü
      if (birthDate > today) {
        console.warn('Doğum tarihi gelecekte! Bugünden sonra:', birthdate);
        return 0;
      }
      
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      
      //console.log('Hesaplanan yaş:', age);
      return age;
    } catch (error) {
      console.error('Yaş hesaplama hatası:', error);
      return 0;
    }
  };
  
  // Yaşı veya gün/ay olarak süreyi formatla
  const formatAge = (birthdate) => {
    if (!birthdate) return '1 yaşından küçük';
    
    try {
      const today = new Date();
      let birthDate;
      
      // Tarih formatını parse et
      if (typeof birthdate === 'string') {
        const parts = birthdate.split('T')[0].split('-');
        if (parts.length === 3) {
          birthDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
        } else {
          birthDate = new Date(birthdate);
        }
      } else {
        birthDate = new Date(birthdate);
      }
      
      // Geçersiz tarih kontrolü
      if (isNaN(birthDate.getTime())) {
        return '1 yaşından küçük';
      }
      
      // Tam yaş hesapla
      let years = today.getFullYear() - birthDate.getFullYear();
      let months = today.getMonth() - birthDate.getMonth();
      let days = today.getDate() - birthDate.getDate();
      
      // Ayları düzelt
      if (days < 0) {
        months--;
        // Önceki ayın gün sayısını ekle
        const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
        days += lastMonth.getDate();
      }
      
      // Yılları düzelt
      if (months < 0) {
        years--;
        months += 12;
      }
      
      //console.log(`Detaylı yaş: ${years} yıl, ${months} ay, ${days} gün`);
      
      // Formatlanmış yaş ifadesi
      if (years >= 1) {
        return `${years} yaşında`;
      } else if (months >= 1) {
        return `${months} aylık`;
      } else {
        return `${days} günlük`;
      }
    } catch (error) {
      console.error('Yaş formatı hatası:', error);
      return '1 yaşından küçük';
    }
  };
  
  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    return `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`;
  };
  
  // Get gender display information
  const getGenderInfo = () => {
    // child null veya undefined olabilir, kontrol et
    if (!child) return null;
    // gender null, undefined veya unknown olabilir, kontrol et
    if (!child.gender || child.gender === 'unknown') return null;
    
    const isGirl = child.gender === 'female';
    return {
      text: isGirl ? 'Kız' : 'Erkek',
      icon: isGirl ? 'gender-female' : 'gender-male',
      color: isGirl ? '#F06292' : '#2196F3'
    };
  };
  
  // Loading state
  if (isLoading) {
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color={theme.colors.primary} />
        <Text style={styles.loadingText}>Çocuk bilgileri yükleniyor...</Text>
      </View>
    );
  }
  
  // Error state
  if (error) {
    return (
      <View style={styles.container}>
        <View style={styles.errorContainer}>
          <MaterialCommunityIcons name="alert-circle-outline" size={50} color="rgb(125, 76, 236)" style={styles.errorIcon} />
          <Text style={styles.errorText}>{error}</Text>
          <Button mode="contained" onPress={fetchChildData} style={{ backgroundColor: 'rgb(125, 76, 236)' }}>
            Tekrar Dene
          </Button>
        </View>
      </View>
    );
  }
  
  // Not found state
  if (!child) {
    return (
      <View style={styles.container}>
        <View style={styles.errorContainer}>
          <MaterialCommunityIcons name="alert-circle-outline" size={50} color="rgb(125, 76, 236)" style={styles.errorIcon} />
          <Text style={styles.errorTitle}>Hata!</Text>
          <Text style={styles.errorText}>Çocuk bulunamadı</Text>
          <Button 
            mode="contained" 
            onPress={() => navigation.goBack()}
            style={{ backgroundColor: 'rgb(125, 76, 236)' }}
          >
            GERİ DÖN
          </Button>
        </View>
      </View>
    );
  }

  // Değişkenleri render'dan önce hesapla - child kontrol edildikten sonra
  const age = calculateAge(child.dateOfBirth);
  const formattedAge = formatAge(child.dateOfBirth);
  const genderInfo = getGenderInfo();

  return (
    <View style={styles.container}>
      <ScrollView>
        {/* Çocuk Profil Kartı */}
        <Card style={styles.profileCard}>
          <Card.Content>
            <View style={styles.nameContainer}>
              <Title style={styles.nameText}>{`${child.name} ${child.surname}`}</Title>
              <Text style={styles.ageText}>{formattedAge}</Text>
            </View>
            
            <List.Section>
              {child.dateOfBirth && (
                <List.Item
                  title="Doğum Tarihi"
                  description={formatDate(child.dateOfBirth)}
                  left={props => <List.Icon {...props} icon="calendar" />}
                />
              )}
              
              {genderInfo && (
                <List.Item
                  title="Cinsiyet"
                  description={genderInfo.text}
                  left={props => <List.Icon {...props} icon={genderInfo.icon} color={genderInfo.color} />}
                />
              )}
              
              {child.tcIdNumber && (
                <List.Item
                  title="TC Kimlik Numarası"
                  description={child.tcIdNumber}
                  left={props => <List.Icon {...props} icon="card-account-details" />}
                />
              )}
              
              {child.hasSpecialNeeds && (
                <List.Item
                  title="Özel Gereksinim"
                  description="Evet"
                  left={props => <List.Icon {...props} icon="alert" color="#e74c3c" />}
                />
              )}
              
              {child.allergies && (
                <List.Item
                  title="Alerjiler"
                  description={child.allergies}
                  left={props => <List.Icon {...props} icon="medical-bag" color="#FF5722" />}
                />
              )}
              
              {child.specialNotes && (
                <List.Item
                  title="Özel Notlar"
                  description={child.specialNotes}
                  left={props => <List.Icon {...props} icon="text-box" color="#4CAF50" />}
                />
              )}
            </List.Section>
            
            <View style={styles.buttonContainer}>
              <Button 
                mode="contained" 
                icon="pencil" 
                onPress={handleEditChild}
                style={[styles.actionButton, { backgroundColor: 'rgb(125, 76, 236)' }]}
                labelStyle={{ color: 'white' }}
              >
                Düzenle
              </Button>
              <Button 
                mode="outlined" 
                icon="delete" 
                onPress={handleDeleteChild}
                style={[styles.actionButton, styles.deleteButton]}
                color="#e74c3c"
              >
                Sil
              </Button>
            </View>
          </Card.Content>
        </Card>
        
        {/* Aktiviteler Bölümü */}
       
      </ScrollView>
      
      {/* Silme onaylama modalı */}
      <Modal
        visible={showModal}
        transparent={true}
        onRequestClose={closeModal}
      >
        <View style={styles.modalContainer}>
          <View style={styles.errorModalContent}>
            <MaterialCommunityIcons 
              name="alert-circle-outline" 
              size={50} 
              color="#FF9800"
              style={styles.errorIcon} 
            />
            
            <Text style={styles.errorModalTitle}>Çocuk Profilini Sil</Text>
            <Text style={styles.errorModalText}>
              {child ? `${child.name} ${child.surname} profilini silmek istediğinize emin misiniz? Bu işlem geri alınamaz.` : ''}
            </Text>
            
            <View style={styles.errorModalButtonContainer}>
              <Button 
                mode="contained" 
                onPress={confirmDelete}
                style={[styles.modalButton, { backgroundColor: 'rgb(125, 76, 236)', flex: 1 }]}
                icon="delete-outline"
                labelStyle={{ color: 'white' }}
              >
                Sil
              </Button>
              <Button 
                mode="outlined" 
                onPress={closeModal}
                style={[styles.modalButton, { flex: 1 }]}
              >
                İptal
              </Button>
            </View>
          </View>
        </View>
      </Modal>
      
      {/* Aktif Ziyaret Hatası Modalı */}
      <Modal
        visible={errorModalVisible}
        transparent={true}
        onRequestClose={closeErrorModal}
      >
        <View style={styles.modalContainer}>
          <View style={styles.errorModalContent}>
            <MaterialCommunityIcons 
              name="alert-circle-outline" 
              size={50} 
              color="#FF9800"
              style={styles.errorIcon} 
            />
            
            <Text style={styles.errorModalTitle}>Silme İşlemi Başarısız</Text>
            <Text style={styles.errorModalText}>{errorMessage}</Text>
            
            <View style={styles.errorModalButtonContainer}>
              <Button 
                mode="contained" 
                onPress={goToActiveVisits}
                style={{ marginTop: 8, backgroundColor: 'rgb(125, 76, 236)' }}
                icon="history"
                labelStyle={{ color: 'white' }}
              >
                Aktif Ziyaretler
              </Button>
              <Button 
                mode="outlined" 
                onPress={closeErrorModal}
                style={styles.modalButton}
              >
                Kapat
              </Button>
            </View>
          </View>
        </View>
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  // Modal Stiller - ParkEntryScreen.js ile uyumlu
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    backgroundColor: 'white',
    borderRadius: 12,
    width: '85%',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    borderWidth: 1,
    borderColor: 'rgba(125, 76, 236, 0.3)',
  },
  modalHeader: {
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(125, 76, 236, 0.3)',
    paddingVertical: 15,
    paddingHorizontal: 20,
    backgroundColor: 'rgba(125, 76, 236, 0.1)',
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: 'rgb(125, 76, 236)',
  },
  modalBody: {
    paddingVertical: 20,
    paddingHorizontal: 20,
    alignItems: 'center',
  },
  warningIcon: {
    marginBottom: 10,
  },
  modalText: {
    fontSize: 16,
    color: 'rgb(90, 50, 180)',
    lineHeight: 24,
    textAlign: 'center',
    marginTop: 10,
  },
  modalFooter: {
    flexDirection: 'row',
    borderTopWidth: 1,
    borderTopColor: 'rgba(125, 76, 236, 0.3)',
  },
  modalButton: {
    flex: 1,
    paddingVertical: 15,
    alignItems: 'center',
  },
  singleButton: {
    backgroundColor: 'rgb(125, 76, 236)',
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
  },
  buttonText: {
    color: 'white',
    fontWeight: '600',
  },
  // Eski modal stilleri (uyumluluk için)
  modalContent: {
    backgroundColor: 'white',
    borderRadius: 15,
    padding: 20,
    width: '90%',
    maxWidth: 400,
    elevation: 5,
    borderWidth: 1,
    borderColor: 'rgba(125, 76, 236, 0.3)',
  },
  modalButtonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  // Hata Modalı Stilleri
  errorIcon: {
    marginBottom: 15,
    alignSelf: 'center',
  },
  errorModalContent: {
    backgroundColor: 'white',
    borderRadius: 15,
    padding: 20,
    width: '90%',
    maxWidth: 400,
    elevation: 5,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    borderWidth: 1,
    borderColor: 'rgba(125, 76, 236, 0.3)',
  },
  errorModalTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 10,
    textAlign: 'center',
    color: 'rgb(125, 76, 236)',
  },
  errorModalText: {
    fontSize: 16,
    marginBottom: 20,
    textAlign: 'center',
    lineHeight: 22,
    color: 'rgb(90, 50, 180)',
  },
  errorModalButtonContainer: {
    flexDirection: 'column',
    justifyContent: 'center',
    marginTop: 10,
  },
  container: {
    flex: 1,
    backgroundColor: 'rgb(232, 162, 249)',
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingText: {
    marginTop: 16,
    fontSize: 16,
    color: 'rgb(90, 50, 180)',
  },
  errorContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  errorTitle: {
    fontSize: 22,
    fontWeight: 'bold',
    color: 'rgb(210, 50, 80)',
    marginVertical: 8,
  },
  errorText: {
    fontSize: 16,
    color: 'rgb(90, 50, 180)',
    textAlign: 'center',
    marginBottom: 20,
  },
  profileCard: {
    margin: 16,
    marginBottom: 8,
    elevation: 3,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: 'rgba(125, 76, 236, 0.3)',
    backgroundColor: 'white',
  },
  nameContainer: {
    marginBottom: 16,
  },
  nameText: {
    fontSize: 24,
    color: 'rgb(125, 76, 236)',
  },
  ageText: {
    fontSize: 16,
    color: 'rgb(90, 50, 180)',
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 16,
  },
  actionButton: {
    flex: 1,
    marginHorizontal: 4,
  },
  deleteButton: {
    borderColor: 'rgb(210, 50, 80)',
  },
  activitiesCard: {
    margin: 16,
    marginTop: 8,
    elevation: 3,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: 'rgba(125, 76, 236, 0.3)',
    backgroundColor: 'white',
  },
  sectionTitle: {
    fontSize: 20,
    color: 'rgb(125, 76, 236)',
  },
  emptyActivities: {
    padding: 20,
    alignItems: 'center',
  },
  emptyText: {
    marginTop: 8,
    color: 'rgb(90, 50, 180)',
    textAlign: 'center',
  },
  addActivityButton: {
    marginTop: 16,
  },
  activitiesList: {
    marginTop: 16,
  },
  modalContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  modalContent: {
    backgroundColor: '#fff',
    padding: 20,
    borderRadius: 10,
    width: '80%',
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  modalText: {
    fontSize: 16,
    color: '#666',
    marginBottom: 20,
  },
  modalButtonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  modalButton: {
    flex: 1,
    marginHorizontal: 4,
  },
});

export default ChildDetailScreen;
